// FILECONTENT_START src/common/components/Button/index.ts
import Button from "./Button";
export default Button;
export type { ButtonProps } from "./Button";

// FILECONTENT_END src/common/components/Button/index.ts